import { useState, useEffect, useRef } from "react";
import { ChevronRight } from "lucide-react";

interface Props {
  text: string;
  isStreaming?: boolean;
}

export function ThinkingBlock({ text, isStreaming = false }: Props) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (expanded && isStreaming && contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [text, expanded, isStreaming]);

  return (
    <div className="my-1 rounded-md border border-colony-border-subtle bg-white/[0.02] overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 w-full px-3 py-1.5 text-left hover:bg-colony-surface-hover transition-colors cursor-pointer"
      >
        <ChevronRight
          className={`w-3 h-3 text-colony-text-tertiary transition-transform ${expanded ? "rotate-90" : ""}`}
        />
        {isStreaming ? (
          <span className="flex items-center gap-1.5 text-[11px] text-colony-text-tertiary">
            <span>Thinking</span>
            <span className="flex items-center gap-0.5">
              <span className="w-1 h-1 rounded-full bg-colony-text-tertiary animate-[pulse_1.4s_ease-in-out_infinite]" />
              <span className="w-1 h-1 rounded-full bg-colony-text-tertiary animate-[pulse_1.4s_ease-in-out_0.2s_infinite]" />
              <span className="w-1 h-1 rounded-full bg-colony-text-tertiary animate-[pulse_1.4s_ease-in-out_0.4s_infinite]" />
            </span>
          </span>
        ) : (
          <span className="text-[11px] text-colony-text-tertiary">Thinking</span>
        )}
      </button>

      {expanded && (
        <div ref={contentRef} className="px-3 pb-2 max-h-[300px] overflow-y-auto" style={{ scrollbarWidth: "thin", scrollbarColor: "#2A2A2F transparent" }}>
          <p className="text-[12px] text-colony-text-secondary leading-[1.6] whitespace-pre-wrap">
            {text}
            {isStreaming && <span className="inline-block w-1 h-3 bg-colony-text-tertiary/60 animate-pulse align-text-bottom ml-0.5" />}
          </p>
        </div>
      )}
    </div>
  );
}
